import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

export function useCoachStudioParams() {
  const { pathname } = useLocation();
  const { id, weekNumber } = useParams() as { id: string; weekNumber?: string };

  const isCoachUrl = useMemo(() => pathname.match(/^\/coach\/\d/), [pathname]);
  const isStudioUrl = useMemo(() => pathname.match(/^\/studio\/\d/), [pathname]);

  return {
    id: parseInt(id),
    weekNumber: weekNumber ? parseInt(weekNumber, 10) : null,
    isCoachUrl,
    isStudioUrl,
  };
}
